import { Component, ChangeDetectionStrategy } from '@angular/core';
import {Input} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-stat',
    templateUrl: './stat.component.html',
    styleUrls: ['./stat.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule]
})
export class StatComponent {

  constructor() { }
  @Input('count') count;
  @Input('title') title: string;
  @Input('amount') amount;
  @Input('accent') accent = 'brand';
  @Input('icon') icon = '';

}
